<template>
<div class="chapter">
<div class="inner_page">
<div id="toc">
<div class="toc-heading"><h3 class="toc-title">Contents</h3></div>
<div id="contents">
<div class="toc-bodymatter-group">
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-001-xhtml">
<p class="element-title"><a href="#/chapter001"><span class="element-title-text">Chapter 1</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-002-xhtml">
<p class="element-title"><a href="#/chapter002"><span class="element-title-text">Chapter 2</span></a></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-003-xhtml">
<p class="element-title"><span href="#/chapter003" title="Link target outside of Sample"><span class="element-title-text">Chapter 3</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-004-xhtml">
<p class="element-title"><span href="#/chapter004" title="Link target outside of Sample"><span class="element-title-text">Chapter 4</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-005-xhtml">
<p class="element-title"><span href="#/chapter005" title="Link target outside of Sample"><span class="element-title-text">Chapter 5</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-006-xhtml">
<p class="element-title"><span href="#/chapter006" title="Link target outside of Sample"><span class="element-title-text">Chapter 6</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-007-xhtml">
<p class="element-title"><span href="#/chapter007" title="Link target outside of Sample"><span class="element-title-text">Chapter 7</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-008-xhtml">
<p class="element-title"><span href="#/chapter008" title="Link target outside of Sample"><span class="element-title-text">Chapter 8</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-009-xhtml">
<p class="element-title"><span href="#/chapter009" title="Link target outside of Sample"><span class="element-title-text">Chapter 9</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-010-xhtml">
<p class="element-title"><span href="#/chapter010" title="Link target outside of Sample"><span class="element-title-text">Chapter 10</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-011-xhtml">
<p class="element-title"><span href="#/chapter011" title="Link target outside of Sample"><span class="element-title-text">Chapter 11</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-012-xhtml">
<p class="element-title"><span href="#/chapter012" title="Link target outside of Sample"><span class="element-title-text">Chapter 12</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-013-xhtml">
<p class="element-title"><span href="#/chapter013" title="Link target outside of Sample"><span class="element-title-text">Chapter 13</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-014-xhtml">
<p class="element-title"><span href="#/chapter014" title="Link target outside of Sample"><span class="element-title-text">Chapter 14</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-015-xhtml">
<p class="element-title"><span href="#/chapter015" title="Link target outside of Sample"><span class="element-title-text">Chapter 15</span></span></p>
</div>
<div class="toc-item toc-item-element-bodymatter toc-item-element-type-chapter has-no-leading-number has-no-children has-no-page-number" id="chapter-016-xhtml">
<p class="element-title"><span href="#/chapter016" title="Link target outside of Sample"><span class="element-title-text">Chapter 16</span></span></p>
</div>
</div>
<div class="toc-backmatter-group">
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number" id="thank-you-xhtml">
<p class="element-title"><span href="#/thankyou" title="Link target outside of Sample"><span class="element-title-text">Thank You</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number" id="right-wolf-right-time-excerpt-xhtml">
<p class="element-title"><span href="#/rightwolfrighttimeexcerpt" title="Link target outside of Sample"><span class="element-title-text">Right Wolf, Right Time Excerpt</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number" id="a-major-attraction-excerpt-xhtml">
<p class="element-title"><span href="#/amajorattractionexcerpt" title="Link target outside of Sample"><span class="element-title-text">A Major Attraction Excerpt</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-none has-no-leading-number has-no-children has-no-page-number" id="to-hunt-a-sainte-excerpt-xhtml">
<p class="element-title"><span href="#/tohuntasainteexcerpt" title="Link target outside of Sample"><span class="element-title-text">To Hunt a Sainte Excerpt</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-also-by has-no-leading-number has-no-children has-no-page-number" id="also-by-marie-xhtml">
<p class="element-title"><span href="#/alsobymarie" title="Link target outside of Sample"><span class="element-title-text">Also by Marie</span></span></p>
</div>
<div class="toc-item toc-item-element-non-bodymatter toc-item-element-type-about-author has-no-leading-number has-no-children has-no-page-number" id="about-the-author-xhtml">
<p class="element-title"><span href="#/abouttheauthor" title="Link target outside of Sample"><span class="element-title-text">About the Author</span></span></p>
</div>
</div>
</div>
<div class="footer"></div>
</div>
</div>
</div>
</template>
<script>

export default {
  name: 'chapter',
  data() {
    return {}
    },
      components: {
    }
  }
</script>



// WEBPACK FOOTER //
// contents.vue?7fea2de0